import { render, staticRenderFns } from "./TemplateMessageModal.vue?vue&type=template&id=a16855a6"
import script from "./TemplateMessageModal.vue?vue&type=script&lang=js"
export * from "./TemplateMessageModal.vue?vue&type=script&lang=js"
import style0 from "./TemplateMessageModal.vue?vue&type=style&index=0&id=a16855a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports